export default __webpack_public_path__ + "static/media/home_furniture.994fe4da.png";